/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { TemplateCellContainer } from "./TemplateCellContainer";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TemplateCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCell, _super);
    function TemplateCell(a) {
        var _this = _super.call(this, a) || this;
        _this.b8 = null;
        _this.b8 = new TemplateCellContainer(a);
        _this.b8.element.setRawStyleProperty("box-sizing", "border-box");
        _this.z.append(_this.b8.element);
        return _this;
    }
    Object.defineProperty(TemplateCell.prototype, "b9", {
        get: function () {
            return this.b8;
        },
        enumerable: true,
        configurable: true
    });
    TemplateCell.prototype.get_r = function () {
        return true;
    };
    TemplateCell.prototype.bh = function (a, b, c) {
        _super.prototype.bh.call(this, a, b, c);
        if (a == "Indent" || a == "IsCollapsable") {
            this.b8.element.setRawStyleProperty("margin-left", this.av + this.ax + this.aw + "px");
        }
    };
    TemplateCell.$t = markType(TemplateCell, 'TemplateCell', GridCellBase.$);
    return TemplateCell;
}(GridCellBase));
export { TemplateCell };
//# sourceMappingURL=TemplateCell.js.map
